import { createContext, useContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { usePreferences } from "hooks/use-preferences"

export const QuickAnswersContext = createContext()

const PREFERENCE_SUBTYPE = "quick-answers"

const DEFAULT_STATE = {
  question: "",
}

// Define which fields should be saved as preferences
const PREFERENCE_FIELDS = [
  "question",
]

function reducer(state, action) {
  return produce(state, draft => {
    switch (action.type) {
      case "setQuestion":
        draft.question = action.question
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setQuestion(question) {
  return {
    type: "setQuestion",
    question,
  }
}

function setPreferences(preferences) {
  return {
    type: "setPreferences",
    preferences,
  }
}

export default function useQuickAnswersContext(parentContext) {
  const parentContextValue = useContext(parentContext)
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)

  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setQuestion: (...args) => dispatch(setQuestion(...args)),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...parentContextValue,
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [contextUpdaters, state, parentContextValue, isPreferencesLoaded])

  return [QuickAnswersContext, contextValue]
}
